import { Activity } from "PFTypes";
import { createContext, useContext } from "react";

export type BookingActivityContextType = {
  id?: number;
  isLoading: boolean;
  activity?: Activity;
  parentActivity?: Activity;
  isActivityFetching: boolean;
  isParentActivityFetching: boolean;
  isActivityError: boolean;
  isParentActivityError: boolean;
};

export const BookingActivityContext = createContext({} as BookingActivityContextType);

export const useBookingActivityContext = () => useContext(BookingActivityContext);
